export default {
  list: [],
  dictionaryList: {},
  dialog: false,
  isEditting: false
}